import React from 'react';
import { Clock, Mic, BarChart3, RefreshCw } from 'lucide-react';
import { Card } from './ui/card';

export const ProductSuite = () => {
  const products = [
    {
      icon: Clock,
      title: 'TimeSync',
      subtitle: 'AI Time & Cost Tracking',
      features: [
        'Foreman-friendly interface',
        'Daily reports auto-generated',
        'Vendor & craft alignment',
        'Cost codes synced automatically',
      ],
      color: '#30D5C8',
    },
    {
      icon: Mic,
      title: 'SiteSync',
      subtitle: 'Voice-to-Schedule Field App',
      features: [
        'Speak tasks, durations, crafts',
        'Logic ties generated instantly',
        'Integrates with Primavera P6 & Oracle',
      ],
      color: '#30D5C8',
    },
    {
      icon: BarChart3,
      title: 'ProjectFlow Dashboard',
      subtitle: 'Live Project Intelligence',
      features: [
        'Live KPIs: CPI, SPI, manpower, constraints',
        'AI-driven project health scoring',
        'Executive-ready reports in one click',
      ],
      color: '#30D5C8',
    },
    {
      icon: RefreshCw,
      title: 'UpdateFlow',
      subtitle: 'Project Change Tracking',
      features: [
        'All changes captured automatically',
        'Instant variance alerts',
        'Full audit trail for QA/QC and leadership',
      ],
      color: '#30D5C8',
    },
  ];

  return (
    <section id="products" className="py-24 bg-[#1A2733] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
            PRODUCT <span className="text-[#30D5C8]">SUITE</span>
          </h2>
          <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] max-w-3xl mx-auto">
            Four powerful tools that work seamlessly together to automate your industrial projects
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <Card
              key={index}
              className="bg-[#0D1115]/80 backdrop-blur-sm border-[#506273]/30 p-8 hover:border-[#30D5C8]/50 transition-all duration-300 card-hover group"
            >
              <div className="flex items-start space-x-4">
                <div
                  className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${product.color}20` }}
                >
                  <product.icon
                    className="text-[#30D5C8]"
                    size={28}
                  />
                </div>
                <div className="flex-1">
                  <h3 className="font-['Montserrat'] font-bold text-2xl text-[#F5F7F8] mb-1">
                    {product.title}
                  </h3>
                  <p className="text-[#30D5C8] font-['Montserrat'] font-semibold text-sm mb-2">
                    {product.subtitle}
                  </p>
                  <p className="text-[#506273] font-['Open_Sans'] text-xs italic mb-3">
                    Patent Pending
                  </p>
                  <ul className="space-y-2">
                    {product.features.map((feature, idx) => (
                      <li
                        key={idx}
                        className="flex items-start text-[#CBD3D9] font-['Open_Sans']"
                      >
                        <span className="text-[#30D5C8] mr-2 mt-1">•</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};